//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import CourseSchedulingModeService from 'app_services/admin/courseScheduling/courseSchedulingModeService'
// @end

// @INFO Import Styles
import './../courseScreen.scss'

// @ADD Component types
interface ICourseScreenFormFilterLayoutProps {
  searchForm: any
  onSearch: () => void
  searchFormInputs?: any
}

const CourseScreenFormFilterLayout: React.FC<ICourseScreenFormFilterLayoutProps> = (props) => {

  const {searchForm} = props

  // @Import services
  const courseSchedulingModeService: CourseSchedulingModeService = new CourseSchedulingModeService()

  const [listOfCourseModes, setListOfCourseModes] = useState<Array<any>>([])

  const { t } = useTranslation()

  useEffect(() => {
    getCourseModes()
  }, [])

  const getCourseModes = async () => {
    const types: Array<any> = []
    const courseModesResponse = await courseSchedulingModeService.list({moodle_id: true})
    if (courseModesResponse) {
      courseModesResponse.courseSchedulingModes.map((type: any) => {
        types.push({ value: type._id, label: type.name })
      })
    }
    setListOfCourseModes(types)
  }
  return(
    <div className="form-filter">
      <h3>Filtros</h3>
      <form className='mb-3 mt-3' onSubmit={searchForm.handleSubmit(props.onSearch)}>
        <div className="row g-3">
          <div className="col-3">
            <div className="input-group mb-3 ">
              <input
                className='form-control search-input'
                type='text'
                name='course_scheduling_code'
                id='course_scheduling_code'
                placeholder={t('screens.course_scheduling.search.code')}
                defaultValue={props?.searchFormInputs?.course_scheduling_code}
                ref={searchForm.register()}
              />
              <span className="input-group-text">
                <IconComponent svg='Search' width='24px' height='24px' color='white' />
              </span>
            </div>
          </div>

          <div className="col-3">
            <ReactSelectComponent
              identifier='mode'
              options={listOfCourseModes}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.mode) ? [props?.searchFormInputs?.mode] : []}
              isMulti={false}
              required={false}
              placeholder={t('labels.course_scheduling.schedulingMode')}
            />
          </div>
          <div className="col-12 text-right">
            <button type="submit" className="btn btn-primary">
              Buscar
            </button>
            &nbsp;&nbsp;&nbsp;
            <button type="button" className="btn btn-secondary" onClick={() => props.onSearch()}>
              Limpiar
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CourseScreenFormFilterLayout
